import request from '@/utils/request'
// 手动转交工单
export function transferOrder(data) {
  return request({
    url: '/health-doctor-assistant/workOrder/transferOrder',
    method: 'post',
    data: data
  })
}
//  工单在工作台中存在的关联工单
export function queryRelationOrder(data) {
  return request({
    url: '/health-doctor-assistant/workOrder/queryRelationOrder',
    method: 'post',
    data: data
  })
}
// 查询坐班中，休息中的医助
export function queryAllUser() {
  return request({
    url: '/health-doctor-assistant/doctor-assistant/queryTransferUserList',
    method: 'get'
  })
}
//  （新）转交工单
export function transferNewOrder(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/v2/transferOrder',
    method: 'post',
    data: data
  })
}
// (新)查询关联工单列表
export function queryRelationOrderList(params) {
  return request({
    url: 'health-doctor-assistant/workOrderCenter/queryRelationOrder',
    method: 'get',
    params
  })
}
